import { render } from "./LabelOrderDetailPage.vue?vue&type=template&id=62e70c8f&scoped=true"
import script from "./LabelOrderDetailPage.vue?vue&type=script&lang=js"
export * from "./LabelOrderDetailPage.vue?vue&type=script&lang=js"

import "./LabelOrderDetailPage.vue?vue&type=style&index=0&id=62e70c8f&scoped=true&lang=css"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e70c8f"]])

export default __exports__